module.exports = __webpack_public_path__ + "img/224.dba2ec27.jpg";